var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { RequestClient } from "../basics/request-client.service";
import { autoinject } from "aurelia-framework";
import { TokenClient } from "../authentication/token-client.service";
import { Api } from "../../constants/modules/api.constants";
import { toNative } from "../../utilities/promise-utils";
var WinningNominationClaimClientService = /** @class */ (function () {
    function WinningNominationClaimClientService(requestClient, tokenClient) {
        this.requestClient = requestClient;
        this.tokenClient = tokenClient;
    }
    WinningNominationClaimClientService.prototype.getWinningNominationClaim = function (id) {
        return toNative(this.requestClient.get(Api.ManageWinningNominationClaims.Get, { id: id }));
    };
    WinningNominationClaimClientService.prototype.getInstantGameWinningClaim = function (id) {
        return toNative(this.requestClient.get(Api.ManageWinningNominationClaims.GetInstantGame, { id: id }));
    };
    WinningNominationClaimClientService.prototype.getSweepstakeWinningClaim = function (id) {
        return toNative(this.requestClient.get(Api.ManageWinningNominationClaims.GetSweepstake, { id: id }));
    };
    WinningNominationClaimClientService.prototype.save = function (request) {
        return toNative(this.requestClient.post(Api.ManageWinningNominationClaims.Save, {}, request));
    };
    WinningNominationClaimClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [RequestClient, TokenClient])
    ], WinningNominationClaimClientService);
    return WinningNominationClaimClientService;
}());
export { WinningNominationClaimClientService };
